<template>
    <div class="block3">
        <div class="page-box-layout">
            <div class="hd">
                <img class="bg" src="@/assets/img/index/block3-bg.png" />
                <h1 data-aos="fade-down">ShowStart</h1>
                <div data-aos="zoom-in" class="line">
                    <span>x</span>
                </div>
                <div class="text">
                    <div class="left">Release</div>
                    <div data-aos="zoom-in-left" class="right">
                        <span></span>
                        <span></span>
                        <p>
                            任凭这旅程越来越孤单
                            <br />
                            你在我面前越来越茫然
                            <br />
                            丢不下的行李是我不变的心
                            <br />
                            <br />
                            音乐是一条充满快乐却也充满艰险的道路
                            <br />
                            每一个同行的你
                            <br />
                            秀动发行希望与你同行
                        </p>
                        <p class="r">
                            <img class="sign" src="@/assets/img/index/laolang.png" />
                        </p>
                    </div>
                </div>
            </div>
            <div class="bd">
                <div data-aos="fade-down" class="title">Music Works</div>
                <p data-aos="fade" class="text">来自秀动发行的音乐作品</p>
                <div class="albums">
                    <div class="wrapper">
                        <div class="column-block">
                            <div
                                :class="['column', columnIndex == 1 ? 'top' : '']"
                                v-for="(column, columnIndex) in dividedColumns"
                                :key="columnIndex"
                            >
                                <div class="item" v-for="(item, itemIndex) in column" :key="itemIndex">
                                    <el-image :src="`${$store.state.config.imageUrl}${item.albumImage}`"></el-image>
                                    <div class="cont">
                                        <p class="name">{{ item.mainArtistName }}</p>
                                        <p class="song-name">《{{ item.albumName }}》</p>
                                    </div>
                                    <span class="el-icon-delete" @click="onDel(item, 2)" title="点击删除"></span>
                                </div>
                            </div>
                        </div>
                        <div class="column-block">
                            <div
                                :class="['column', columnIndex == 1 ? 'top' : '']"
                                v-for="(column, columnIndex) in dividedColumns"
                                :key="columnIndex"
                            >
                                <div class="item" v-for="(item, itemIndex) in column" :key="itemIndex">
                                    <el-image :src="`${$store.state.config.imageUrl}${item.albumImage}`"></el-image>
                                    <div class="cont">
                                        <p class="name">{{ item.mainArtistName }}</p>
                                        <p class="song-name">《{{ item.albumName }}》</p>
                                    </div>
                                    <span class="el-icon-delete" @click="onDel(item, 2)" title="点击删除"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="btn-box">
                <div class="text">x Release</div>
                <router-link class="btn" :to="userInfo ? '/manage/dashboard' : '/login'">加入秀动发行</router-link>
            </div> -->
            <div data-aos="fade" class="video-box">
                <video
                    src="https://static01.ssrelease.com/0105/M00/E6/EE/ChR45WKmrQKAejDSAisA3regmqU279.mp4"
                    ref="pageVideo"
                    :controls="videoPlaying"
                >
                    抱歉，您的浏览器不支持内嵌视频
                </video>
                <div v-show="!videoPlaying" class="mask"></div>
                <div v-show="!videoPlaying" class="video-btn" @click="$refs.pageVideo.play()"><span class="el-icon-caret-right"></span></div>
            </div>
            <div class="text-end">
                <strong data-aos="fade-up">“这个世界需要你的音乐”</strong>
                <p data-aos="fade-up">The world needs your music</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            albums: [],
            videoPlaying: false,
        };
    },
    computed: {
        userInfo() {
            return this.$store.state && this.$store.state.userInfo;
        },
        dividedColumns() {
            const columns = Array.from({length: 3}, () => []);
            this.albums.forEach((item, index) => {
                columns[index % 3].push(item);
            });
            return columns;
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (!this.$refs.pageVideo) return;
            this.$refs.pageVideo.addEventListener('play', () => {
                this.videoPlaying = true;
            });
            this.$refs.pageVideo.addEventListener('pause', () => {
                this.videoPlaying = false;
            });
            this.$refs.pageVideo.addEventListener('ended', () => {
                this.videoPlaying = false;
            });
        });
    },
    created() {
        this.getAlbum();
    },
    methods: {
        async getAlbum() {
            const {preview} = this.$route.query;
            const respnonse = await this.$request({
                url: '/banner/cp/album/list',
                params: {status: preview && preview === 'draft' ? 0 : 1},
                method: 'GET',
            });
            const {state, msg, result} = respnonse.data;
            if (!state) return this.$message.error(msg || '获取专辑列表失败');
            this.albums =
                result.length > 0
                    ? result
                    : [
                          {
                              albumImage: '/0513/M00/58/8D/ChAKFGSP0tOAH0gOAA1s3U1CYm8173.jpg',
                              mainArtistName: 'Toryondacloud & 90sGodFather & LilRicky & 力宝',
                              albumName: '《90SGODFATHER》',
                          },
                          {
                              albumImage: '/0513/M00/41/3E/ChAKCGRZ8C6AN7JgAAaYa-xNnt8551.jpg',
                              mainArtistName: '陈文贤 & Mans曼',
                              albumName: '《爱的距离》',
                          },
                          {
                              albumImage: '/0103/M00/91/BC/ChR45GGbO0uAL1iGAAGnKWRVxZ0572.jpg',
                              mainArtistName: '陶冶abouT-y',
                              albumName: '《被窝里的陌生人》',
                          },
                          {
                              albumImage: '/0103/M00/82/84/ChR45WFvyLWAdNzpAAB6y5CgXnc300.jpg',
                              mainArtistName: '程子不是橙子',
                              albumName: '《程子和他的民谣故事》',
                          },
                          {albumImage: '/0103/M00/BA/EB/ChR45GIx7BGAIsABAAHB5uuAn4Q675.jpg', mainArtistName: 'Sleepy Cat', albumName: '《出山》'},
                          {albumImage: '/0513/M00/21/11/ChAKFGM2ZuaAOICBACpzSG3IYg8490.jpg', mainArtistName: '杨蟒特', albumName: '《川西坝子》'},
                          {
                              albumImage: '/0102/M00/F0/6F/ChR45WK1XBuAYKwmAC_0WuAj7sw760.jpg',
                              mainArtistName: '你的大表哥曲甲 & KidNam索南',
                              albumName: '《次仁拉索》',
                          },
                          {
                              albumImage: '/0513/M00/4D/01/ChAKFGSGsEyAFtcbAADi2iduEkY325.jpg',
                              mainArtistName: 'KOALA & 艾里克',
                              albumName: '《东北猎豹》',
                          },
                          {
                              albumImage: '/0513/M00/F5/E3/ChAKFGRsx3WAaMziABmYmFIdJnk093.jpg',
                              mainArtistName: '塔松Tason & Double K7',
                              albumName: '《都拿走freestyle》',
                          },
                          {albumImage: '/0513/M00/39/3F/ChAKFGSARxuAJ6VeAADcFyj1Wa0616.jpg', mainArtistName: '祝斯', albumName: '《多雨的季节》'},
                          {albumImage: '/0513/M00/E4/9A/ChAKFGPkuyKALHAuAAQYPp8-sTY877.jpg', mainArtistName: 'K.I', albumName: '《發財freestyle》'},
                          {
                              albumImage: '/0103/M00/8B/64/ChR45WGMj7iAIQpsAAfY18U3yic689.jpg',
                              mainArtistName: '漏网之鱼乐队',
                              albumName: '《反转向往》',
                          },
                          {
                              albumImage: '/0103/M00/CA/38/ChR45GJeX8iAZs6pAA8_TOcyZkg501.jpg',
                              mainArtistName: 'TE27 & 赵柯叙 & 刘琪',
                              albumName: '《荒唐幻想》',
                          },
                          {
                              albumImage: '/0513/M00/BE/72/ChAKFGRDqDmAF62nAAn_ljzEmWc843.jpg',
                              mainArtistName: 'GimmeFivve & Drozzy',
                              albumName: '《回忆摩天轮（Prod.Pieper Beats）》',
                          },
                          {
                              albumImage: '/0513/M00/A2/A4/ChAKCGQPAKiANhu_AATXGrPSS1Q640.jpg',
                              mainArtistName: 'Aaron Storm & Pilll',
                              albumName: '《康斯坦丁》',
                          },
                      ];
            document.body.style = `--album-height: -${parseInt(this.albums.length / 3) * 537 - 190}px`;
        },
    },
};
</script>
<style lang="scss" scoped>
@keyframes rowup {
    from {
        transform: translateY(0%);
    }
    to {
        transform: translateY(var(--album-height));
    }
}
.block3 {
    background: #000000;
    position: relative;
    .hd {
        position: relative;
        min-height: 900px;
        .bg {
            position: absolute;
            top: 50px;
            left: 0px;
            width: 654px;
        }
        h1 {
            font-size: 200px;
            font-weight: bold;
            color: #ffffff;
            line-height: 288px;
            position: absolute;
            z-index: 9;
            top: 280px;
            right: 0px;
        }
        .line {
            height: 6px;
            background: #fff;
            right: 0px;
            top: 600px;
            left: 30px;
            position: absolute;
            span {
                font-size: 24px;
                font-weight: bold;
                color: #ffffff;
                line-height: 35px;
                position: absolute;
                top: -17px;
                left: -30px;
            }
        }
        .text {
            display: flex;
            position: absolute;
            top: 650px;
            width: 100%;
            left: 0px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            line-height: 29px;
            &::after {
                content: '';
                position: absolute;
                width: 762px;
                height: 1px;
                background: #979797;
                left: 0px;
                bottom: 90px;
            }
            .right {
                flex: 1;
                margin-left: 720px;
                position: relative;
                text-align: right;
                p.r {
                    margin-top: 30px;
                    .sign {
                        width: 120px;
                    }
                }
                span {
                    width: 12px;
                    height: 12px;
                    background: #ffffff;
                    border-radius: 50%;
                    position: absolute;
                    top: 8px;
                    left: -95px;
                    &:nth-child(1) {
                        top: 65px;
                    }
                }
            }
        }
    }
    .bd {
        border-bottom: 2px solid #979797;
        padding-bottom: 171px;
        height: 2115px;
        margin-bottom: 170px;
        .title {
            font-weight: bold;
            color: #ffffff;
            line-height: 70px;
            font-size: 48px;
        }
        .text {
            font-weight: 600;
            color: #ffffff;
            line-height: 33px;
            font-size: 24px;
            margin-top: 24px;
        }
        .albums {
            position: relative;
            margin-top: 73px;
            height: 1710px;
            overflow: hidden;
            .wrapper {
                animation: rowup 30s linear infinite;
            }
            .column-block {
                display: flex;
                &:nth-child(2n) {
                    margin-top: -190px;
                }
            }
            &::after {
                content: '';
                position: absolute;
                bottom: 0px;
                left: 0px;
                width: 100%;
                background: linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
                height: 300px;
                z-index: 1;
            }
            &::before {
                content: '';
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
                height: 300px;
                z-index: 1;
            }
            .column {
                flex: 1;
                width: 374px;
                &.top {
                    margin-top: 190px;
                }
            }
            .item {
                position: relative;
                width: 374px;
                .el-image {
                    height: 374px;
                    width: 374px;
                    border-radius: 8px;
                }
            }
            .cont {
                margin-top: 30px;
                border-right: 1px solid #ffffff;
                height: 97px;
                margin-bottom: 10px;
            }
            p {
                font-weight: 600;
                color: #ffffff;
                line-height: 20px;
                font-size: 14px;
            }
        }
    }
    .video-box {
        height: 642px;
        width: 1170px;
        background: #000000;
        border-radius: 15px;
        border: 1px solid #7f7f7f;
        margin: 0 auto;
        padding: 20px 50px;
        position: relative;
        overflow: hidden;
        .mask {
            content: '';
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            background: rgba($color: #000000, $alpha: 0.42);
            z-index: 1;
        }
        video {
            height: 100%;
            vertical-align: middle;
            margin: 0 auto;
        }
        .video-btn {
            position: absolute;
            width: 170px;
            height: 170px;
            border-radius: 50%;
            text-align: center;
            line-height: 170px;
            background-color: #fff;
            left: 50%;
            top: 50%;
            margin-top: -85px;
            margin-left: -85px;
            font-size: 30px;
            cursor: pointer;
            z-index: 9;
        }
    }
    .text-end {
        text-align: center;
        padding: 58px 0 190px;
        strong {
            font-size: 18px;
            font-weight: bold;
            color: #ffffff;
            line-height: 25px;
            letter-spacing: 2px;
        }
        p {
            font-size: 11px;
            font-weight: bold;
            color: #ffffff;
            line-height: 17px;
            letter-spacing: 1px;
            margin-top: 8px;
        }
    }
}
</style>
